// Generated by ReScript, PLEASE EDIT WITH CARE


var supportedLanguages = {
  hd: /* English */0,
  tl: {
    hd: /* Hindi */1,
    tl: {
      hd: /* Kannada */2,
      tl: {
        hd: /* Tamil */3,
        tl: {
          hd: /* Telugu */4,
          tl: {
            hd: /* Marathi */5,
            tl: /* [] */0
          }
        }
      }
    }
  }
};

export {
  supportedLanguages ,
  
}
/* No side effect */
